/******************************************************
 * Tag Preview Integration
 * Version: 1.16.1
 * (front side = spiral approach,
 *  back side = simple "biggest possible" approach w/ margin)
 ******************************************************/

window.TagPreviewIntegration = {
  debug: false,

  // ==================================================
  // State
  // ==================================================
  state: {
    frontLine1: '',
    frontLine2: '',
    backLine1: '',
    backLine2: '',
    backLine3: '',
    frontFont: '',
    backFont: '',
    frontDesign: '',
    backDesign: '',
    showBack: false,
    color: 'silver'
  },

  _updateTimer: null,

  // ==================================================
  // Constants & Lookups
  // ==================================================
  frontDesignImageMap: {
    // “plain” means no design — we keep it as an empty string
    // so backgroundImage becomes "none".
    plain: '',

    floral:     'https://cdn.shopify.com/s/files/1/0248/0714/5544/files/tag-bg-1-noborder.png',
    mountains:  'https://cdn.shopify.com/s/files/1/0248/0714/5544/files/tag-mountain-noborder.png?v=1739300031',
    ribbon:     'https://cdn.shopify.com/s/files/1/0248/0714/5544/files/tag-bg-5-noborder.png?v=1739300622',
    palm:       'https://cdn.shopify.com/s/files/1/0248/0714/5544/files/tag-bg-3-noborder.png?v=1739300664',
    hearts:     'https://cdn.shopify.com/s/files/1/0248/0714/5544/files/tag-bg-4-noborder.png?v=1739300703',
    crown:      'https://cdn.shopify.com/s/files/1/0248/0714/5544/files/tag-6-noborder.png?v=1739300741',
    rocket:     'https://cdn.shopify.com/s/files/1/0248/0714/5544/files/tag-noborder-rocketship.png?v=1739464128',
    boat:       'https://cdn.shopify.com/s/files/1/0248/0714/5544/files/tag-noborder-boat.png?v=1739464318',
    lighthouse: 'https://cdn.shopify.com/s/files/1/0248/0714/5544/files/tag-noborder-lighthouse.png?v=1739464434',
    orchid:     'https://cdn.shopify.com/s/files/1/0248/0714/5544/files/tag-noborder-orchid.png?v=1739502721',
    disco:      'https://cdn.shopify.com/s/files/1/0248/0714/5544/files/tag-noborder-disco.png?v=1739503299',
    blossom:    'https://cdn.shopify.com/s/files/1/0248/0714/5544/files/tag-noborder-blossom.png?v=1739538741',
    desert:     'https://cdn.shopify.com/s/files/1/0248/0714/5544/files/desert.png?v=1751043479',
    boots:      'https://cdn.shopify.com/s/files/1/0248/0714/5544/files/boots.png?v=1751044001',
    piggy:      'https://cdn.shopify.com/s/files/1/0248/0714/5544/files/piggy.png?v=1751044141',
    turtle:     'https://cdn.shopify.com/s/files/1/0248/0714/5544/files/turtle.png?v=1751044253',
    seashell:   'https://cdn.shopify.com/s/files/1/0248/0714/5544/files/seashell.png?v=1751044917',
    unicorn:    'https://cdn.shopify.com/s/files/1/0248/0714/5544/files/unicorn.png?v=1751045008',
    bumblebee:  'https://cdn.shopify.com/s/files/1/0248/0714/5544/files/bumblebee.png?v=1751045153',
    honeycomb:  'https://cdn.shopify.com/s/files/1/0248/0714/5544/files/honeycomb.png?v=1751045299',
    butterfly:  'https://cdn.shopify.com/s/files/1/0248/0714/5544/files/butterfly.png?v=1751045511',
    sunflower:  'https://cdn.shopify.com/s/files/1/0248/0714/5544/files/sunflower.png?v=1751045723',
    bonfire:    'https://cdn.shopify.com/s/files/1/0248/0714/5544/files/bonfire.png?v=1751045806',
    planet:     'https://cdn.shopify.com/s/files/1/0248/0714/5544/files/planet.png?v=1751045891',
    cherry:     'https://cdn.shopify.com/s/files/1/0248/0714/5544/files/cherry.png?v=1751047101',
    strawberry: 'https://cdn.shopify.com/s/files/1/0248/0714/5544/files/strawberry.png?v=1751047206',
    paradise:   'https://cdn.shopify.com/s/files/1/0248/0714/5544/files/paradise.png?v=1751047304',
    donut:      'https://cdn.shopify.com/s/files/1/0248/0714/5544/files/donut.png?v=1751047504',
    baseball:   'https://cdn.shopify.com/s/files/1/0248/0714/5544/files/baseball.png?v=1751047622',
    football:   'https://cdn.shopify.com/s/files/1/0248/0714/5544/files/football.png?v=1751047706',
    basketball: 'https://cdn.shopify.com/s/files/1/0248/0714/5544/files/basketball.png?v=1751047782',
    soccer:     'https://cdn.shopify.com/s/files/1/0248/0714/5544/files/soccer.png?v=1751047880',
  },
  backDesignImageMap: {
    // Populate if you have back designs; otherwise empty
  },

  fontMap: {
    Holland:   'Holland, sans-serif',
    Elise:     'Elise, sans-serif',
    Elise3D:   'Elise3D, sans-serif',
    Billy:     'Billy, sans-serif',
    Blanch:    'Blanch, sans-serif',
    Heartland: 'Heartland, sans-serif',
    Bison:     'Bison, sans-serif',
    Dmserif:   'DM Serif Display, serif',
    Anton:     'Anton, sans-serif',
    Brygada:   "'Brygada 1918', serif",
    Tropiline: 'Tropiline, cursive',
    Marcellus: 'Marcellus, serif',
    Roboto:    'Roboto, sans-serif',
    Liberator: 'Liberator, sans-serif',
    // Halloween 2026, from Jon. Self-hosted as theme assets; the @font-face
    // blocks live in templates/product.fontpreviewer.liquid, NOT in
    // theme.scss.liquid (a failed SCSS transform takes the whole storefront
    // stylesheet down — see the 2026-04-19 incident).
    //
    // FRONT OF TAG ONLY. Both files contain exactly 63 glyphs — space, 0-9,
    // A-Z, a-z — and no punctuation whatsoever. The back of the tag is where
    // phone numbers and phrases go ("555-123-4567", "LOST, CALL"), and a
    // missing glyph falls back to another font silently, so the preview would
    // show a spooky name with an ordinary hyphen while the engraving uses the
    // real file. Do not add these to the back font option.
    SpookyDrip:   "'Spooky Drip', cursive",
    SpookyGothic: "'Spooky Gothic', cursive"
  },

  // Map variant values → design keys
  frontDesignValueMap: {
    v_18282337: 'floral',
    v_18282338: 'ribbon',
    v_18282339: 'mountains',
    v_18282486: 'palm',
    v_18282488: 'hearts',
    v_18298511: 'crown',
    v_18312628: 'rocket',
    v_18312629: 'boat',
    v_18312630: 'lighthouse',
    v_18312631: 'orchid',
    v_18333911: 'disco',
    v_18335694: 'blossom',
    v_18355058: 'plain',
    v_19570660: 'desert',
    v_19570661: 'boots',
    v_19570662: 'piggy',
    v_19570663: 'turtle',
    v_19570664: 'seashell',
    v_19570665: 'unicorn',
    v_19570666: 'bumblebee',
    v_19570667: 'honeycomb',
    v_19570429: 'butterfly',
    v_19570659: 'sunflower',
    v_19570668: 'bonfire',
    v_19570669: 'planet',
    v_19570672: 'cherry',
    v_19570673: 'strawberry',
    v_19570670: 'paradise',
    v_19570671: 'donut',
    v_19570674: 'baseball',
    v_19570675: 'football',
    v_19570676: 'basketball',
    v_19570677: 'soccer',
    
  },
  // If you have any back designs:
  backDesignValueMap: {},

  fontValueMap: {
    v_18282489: 'Holland',
    v_18282492: 'Elise3D',
    v_18310953: 'Elise',
    v_18282493: 'Billy',
    v_18289393: 'Blanch',
    v_18282494: 'Heartland',
    v_18282501: 'Bison',
    v_18288363: 'Dmserif',
    v_18282496: 'Anton',
    v_18282498: 'Tropiline',
    v_18352068: 'Tropiline',
    v_18352067: 'Brygada',
    v_18282497: 'Brygada',
    // Back-of-tag "Marcellus". It is a live, selectable, active storefront
    // option, but was missing here, so fontMap lookup fell through to
    // 'inherit' and the preview silently rendered in the theme body font.
    v_18282499: 'Marcellus'
  },

  fontLoadMap: {
    Anton:     'https://fonts.googleapis.com/css2?family=Anton&display=swap',
    Brygada:   'https://fonts.googleapis.com/css2?family=Brygada+1918:wght@700&display=swap',
    Marcellus: 'https://fonts.googleapis.com/css2?family=Marcellus&display=swap',
    Roboto:    'https://fonts.googleapis.com/css2?family=Roboto&display=swap',
    Dmserif:   'https://fonts.googleapis.com/css2?family=DM+Serif+Display&display=swap'
  },

  frontMaskDataMap: {},
  backMaskDataMap: {},
  loadedFonts: new Set(),

  // Canvas geometry
  CANVAS_SIZE: 300,
  CIRCLE_RADIUS: 150,
  HOLE_CENTER_X: 150,
  HOLE_CENTER_Y: 30,
  HOLE_RADIUS: 12,

  FRONT_AVOID_MARGIN: 20,
  BACK_AVOID_MARGIN: 10,

  init() {
    console.log('TagPreviewIntegration init called');
    this.preloadAllDesigns()
      .then(() => {
        this.insertPreviewHTML();
        this.waitForMageworx();
      })
      .catch(err => {
        console.warn('Error preloading designs', err);
        this.insertPreviewHTML();
        this.waitForMageworx();
      });
  },

  async preloadAllDesigns() {
    // FRONT side
    const frontKeys = Object.keys(this.frontDesignImageMap);
    // Also push '' so we have a fallback mask for an empty key
    frontKeys.push('');

    for (const key of frontKeys) {
      // If key is empty string or "plain", build a ring-hole mask
      if (!key || key === 'plain') {
        this.frontMaskDataMap[key] = this.buildHoleMask();
        continue;
      }
      const url = this.frontDesignImageMap[key];
      if (!url) {
        // fallback: hole mask
        this.frontMaskDataMap[key] = this.buildHoleMask();
        continue;
      }
      const loaded = await this.loadMaskData(url);
      // Paint the ring hole black
      this.paintRingHoleBlack(loaded);
      this.frontMaskDataMap[key] = loaded;
    }

    // BACK side (no ring hole)
    const backKeys = Object.keys(this.backDesignImageMap);
    backKeys.push('_blank');
    for (const key of backKeys) {
      if (key === '_blank') {
        // white mask for blank back
        const blankCanvas = document.createElement('canvas');
        blankCanvas.width = this.CANVAS_SIZE;
        blankCanvas.height = this.CANVAS_SIZE;
        const bc = blankCanvas.getContext('2d');
        bc.fillStyle = '#fff';
        bc.fillRect(0, 0, this.CANVAS_SIZE, this.CANVAS_SIZE);
        this.backMaskDataMap['_blank'] = bc.getImageData(0, 0, this.CANVAS_SIZE, this.CANVAS_SIZE);
        continue;
      }
      const url = this.backDesignImageMap[key];
      if (!url) {
        // fallback: all white
        const blankCanvas = document.createElement('canvas');
        blankCanvas.width = this.CANVAS_SIZE;
        blankCanvas.height = this.CANVAS_SIZE;
        const bc = blankCanvas.getContext('2d');
        bc.fillStyle = '#fff';
        bc.fillRect(0, 0, this.CANVAS_SIZE, this.CANVAS_SIZE);
        this.backMaskDataMap[key] = bc.getImageData(0, 0, this.CANVAS_SIZE, this.CANVAS_SIZE);
        continue;
      }
      const loaded = await this.loadMaskData(url);
      // no hole for back
      this.backMaskDataMap[key] = loaded;
    }
    console.log('Preload done');
  },

  insertPreviewHTML() {
    const previewHTML = 
      `<div class="tag-preview-container">
        <h3 class="preview-title">Live Preview</h3>
        <p class="preview-instructions">
        Customize front text (dog’s name, etc.) + optional back text (phone/notes). 
        Pick a design & font. Then click <strong>Show Back</strong> to flip sides! Refresh design choice updates by flipping between Back & Front. 
        </p>
        <div class="preview-controls">
          <button type="button" class="preview-btn flip-btn">
            <span class="btn-icon">⇋</span>
            <span class="btn-text">Show Back</span>
          </button>
        </div>
        <div class="preview-display">
          <div class="tag-preview">
            <div class="preview-lines"></div>
            <div class="ring-hole-overlay"></div>
            <div class="loading-spinner"></div>
          </div>
          <div class="preview-info">1.18" diameter • Front side</div>
        </div>
      </div>`;

    const styleTag = document.createElement('style');
    styleTag.textContent = `
      .tag-preview-container {
        width: 100%;
        box-sizing: border-box;
        margin: 20px 0;
        padding: 20px;
        border: 1px solid #e5e7eb;
        border-radius: 8px;
        background: #ffffff;
        text-align: center;
        box-shadow: 0 2px 8px rgba(0,0,0,0.08);
      }
      .preview-title {
        margin-bottom: 8px;
        font-size: 18px;
        font-weight: 600;
      }
      .preview-instructions {
        color: #444;
        font-size: 14px;
        margin-bottom: 15px;
        line-height: 1.4;
      }
      .preview-controls {
        display: inline-flex;
        gap: 10px;
        margin-bottom: 20px;
      }
      .preview-btn {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 8px 16px;
        border: 1px solid #e5e7eb;
        border-radius: 4px;
        background: white;
        cursor: pointer;
        transition: all 0.2s ease;
      }
      .preview-btn:hover {
        background: #f5f5f5;
        border-color: #d1d5db;
      }
      .flip-btn {
        background-color: #f5f5f5;
        border: 2px solid #ccc;
        font-weight: 600;
        color: #333;
        padding: 6px 12px;
        transition: background-color 0.3s ease, transform 0.3s ease;
      }
      .flip-btn:hover {
        background-color: #eaeaea;
        transform: translateY(-1px);
      }
      .preview-display {
        width: 300px;
        margin: 0 auto;
      }
      .tag-preview {
        position: relative;
        width: 300px;
        height: 300px;
        border-radius: 50%;
        margin: 0 auto 10px auto;
        background-size: 320px 320px;
        background-position: center;
        background-repeat: no-repeat;
        overflow: hidden;
        box-shadow: inset 0 0 5px rgba(0,0,0,0.1);
      }
      .tag-preview::before {
        content: "";
        position: absolute;
        inset: 0;
        border-radius: 50%;
        border: 2px solid black;
        pointer-events: none;
      }
      .preview-lines {
        position: absolute;
        left: 0; right: 0; top: 0; bottom: auto;
        pointer-events: none;
        font-weight: 500;
        transition: opacity 0.2s ease-in;
      }
      .preview-line {
        position: absolute;
        margin: 0;
        padding: 0;
        line-height: 1.0;
        text-align: center;
      }
      .preview-info {
        font-size: 12px;
        color: #666;
      }
      .ring-hole-overlay {
        position: absolute;
        top: 30px;
        left: 50%;
        width: 24px;
        height: 24px;
        margin-left: -12px;
        border: 2px solid black;
        border-radius: 50%;
        background: white;
        pointer-events: none;
      }
      .loading-spinner {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 30px;
        height: 30px;
        margin: -15px 0 0 -15px;
        border: 3px solid #ccc;
        border-top: 3px solid #333;
        border-radius: 50%;
        animation: spin 1s linear infinite;
        z-index: 100;
        display: none;
      }
      @keyframes spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
      }
      .back-side-active {
        border-color: #fa9e9e !important;
      }
      /* Hide border & ring hole for laser captures */
      .no-laser-border.tag-preview::before {
        display: none !important;
      }
      .no-laser-border .ring-hole-overlay {
        display: none !important;
      }
      .no-laser-border .loading-spinner {
        display: none !important;
      }
    `;
    document.head.appendChild(styleTag);

    const mwForm = document.querySelector('.mw-product-options');
    const productForm = document.querySelector('.product-form');
    const insertionPoint = mwForm || productForm;
    if (insertionPoint) {
      const container = document.createElement('div');
      container.innerHTML = previewHTML;
      insertionPoint.after(container);
    }
  },

  waitForMageworx() {
    const observer = new MutationObserver((_, obs) => {
      const mwForm = document.querySelector('.mw-product-options');
      if (mwForm) {
        obs.disconnect();
        this.setupEventListeners();
        this.connectToMageworxFields();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  },

  setupEventListeners() {
    const flipBtn = document.querySelector('.flip-btn');
    if (!flipBtn) return;
    flipBtn.addEventListener('click', () => {
      this.state.showBack = !this.state.showBack;
      const btnText = flipBtn.querySelector('.btn-text');
      btnText.textContent = this.state.showBack ? 'Show Front' : 'Show Back';
      const info = document.querySelector('.preview-info');
      info.textContent = `1.18" diameter • ${this.state.showBack ? 'Back side' : 'Front side'}`;
      const previewEl = document.querySelector('.tag-preview');
      if (previewEl) {
        if (this.state.showBack) previewEl.classList.add('back-side-active');
        else previewEl.classList.remove('back-side-active');
      }
      // multi-pass after flipping
      this.updatePreview();
      setTimeout(() => this.updatePreview(), 150);
      setTimeout(() => this.updatePreview(), 300);
    });
  },

  connectToMageworxFields() {
    const poll = setInterval(() => {
      const textInputs = [
        ...document.querySelectorAll('input[type="text"]'),
        ...document.querySelectorAll('textarea'),
        ...document.querySelectorAll('.mw-option__text-field input')
      ];
      const fontSelectors = [...document.querySelectorAll('[class*="mw-"] select')];
      const designRadios = [
        ...document.querySelectorAll('input[type="radio"][name^="mw_opts[o_"]')
      ];

      if (textInputs.length || fontSelectors.length || designRadios.length) {
        clearInterval(poll);

        // Listen for text input
        textInputs.forEach(input => {
          input.addEventListener('input', e => {
            const val = e.target.value || '';
            const labelText = this.findRelevantLabel(e.target).toLowerCase();

            if (labelText.includes('front')) {
              if (labelText.includes('line 1')) this.state.frontLine1 = val;
              else if (labelText.includes('line 2')) this.state.frontLine2 = val;
            } else if (labelText.includes('back')) {
              if (labelText.includes('line 1')) this.state.backLine1 = val;
              else if (labelText.includes('line 2')) this.state.backLine2 = val;
              else if (labelText.includes('line 3')) this.state.backLine3 = val;
            }

            const isEditingFront = labelText.includes('front');
            // Only update if the side we're editing is showing
            if ((isEditingFront && !this.state.showBack) || (!isEditingFront && this.state.showBack)) {
              this.updatePreview();
              setTimeout(() => this.updatePreview(), 150);
              setTimeout(() => this.updatePreview(), 300);
            }
          });
        });

        // Font selectors
        fontSelectors.forEach(sel => {
          sel.addEventListener('change', e => {
            const picked = e.target.value?.trim() || '';
            const label = this.findRelevantLabel(e.target).toLowerCase();
            // fontValueMap is a hand-maintained mirror of the MageWorx admin,
            // so a newly added font would otherwise resolve to 'inherit' and
            // preview in the theme body font — the same silent gap that hid
            // Marcellus. Fall back to matching the option's visible title
            // against fontMap, so a value named "Spooky Drip" in the admin
            // works with no theme edit.
            const realFont =
              this.fontValueMap[picked] || this.resolveFontFromLabel(e.target) || picked;

            // If neither the id map nor the title matched, cssFont resolves to
            // 'inherit' and the preview quietly renders in the theme body font.
            // Say so, rather than letting it look deliberate.
            if (!this.fontMap[realFont]) {
              const opt = e.target.selectedOptions ? e.target.selectedOptions[0] : null;
              console.warn(
                '[tag-preview] font ' + picked + ' (' +
                ((opt && opt.textContent) || '?').trim() +
                ') is not mapped; preview will fall back to the theme font. ' +
                'Add it to fontValueMap, or name the option value to match a fontMap key.'
              );
            }

            // Wait for the font to load, then do multiple passes
            this.loadFontIfNeeded(realFont).then(() => {
              if (label.includes('front')) {
                this.state.frontFont = realFont;
                if (!this.state.showBack) {
                  // multi-checks to ensure correct measure after font load
                  this.updatePreview();
                  setTimeout(() => this.updatePreview(), 100);
                  setTimeout(() => this.updatePreview(), 300);
                  setTimeout(() => this.updatePreview(), 600); 
                }
              } else if (label.includes('back')) {
                this.state.backFont = realFont;
                if (this.state.showBack) {
                  // multi-checks to ensure correct measure after font load
                  this.updatePreview();
                  setTimeout(() => this.updatePreview(), 100);
                  setTimeout(() => this.updatePreview(), 300);
                  setTimeout(() => this.updatePreview(), 600);
                }
              }
            });
          });
        });

        // Design radios
        designRadios.forEach(radio => {
          radio.addEventListener('change', e => {
            if (!e.target.checked) return;
            const val = e.target.value;
            // See if it maps to a front design
            const mapped = this.frontDesignValueMap[val];
            if (mapped) {
              this.state.frontDesign = mapped;
              if (!this.state.showBack) {
                this.updatePreview();
              }
              return;
            }
            // Or if it maps to a back design:
            const mappedBack = this.backDesignValueMap[val];
            if (mappedBack) {
              this.state.backDesign = mappedBack;
              if (this.state.showBack) {
                this.updatePreview();
              }
              return;
            }
            // Neither map knows this value. Rather than silently doing nothing
            // (which showed a blank tag on a first pick, or the PREVIOUS
            // design's artwork on a later one), fall back to the swatch's own
            // artwork. See adoptUnmappedDesign.
            this.adoptUnmappedDesign(val, e.target);
          });
        });
      }
    }, 500);

    setTimeout(() => clearInterval(poll), 10000);
  },

  findRelevantLabel(el) {
    // Attempt to find a label referencing el
    if (el.id) {
      const lab = document.querySelector(`label[for="${el.id}"]`);
      if (lab) return lab.textContent.trim();
    }
    // If none, walk up the DOM
    let depth = 5, cur = el.parentElement;
    while (cur && depth > 0) {
      const txt = cur.textContent.toLowerCase();
      if (txt.includes('front') || txt.includes('back') || txt.includes('line')) {
        return txt;
      }
      cur = cur.parentElement;
      depth--;
    }
    return '';
  },

  // Resolve a font from the option's visible title when the value id is not in
  // fontValueMap. Normalised so "Spooky Drip" matches the fontMap key
  // "SpookyDrip". Only ever consulted on a miss, so it cannot disturb the
  // existing values (whose titles deliberately differ from their keys —
  // "Billy Ohio" -> Billy, "DM Serif" -> Dmserif, "Elise (with lace)" -> Elise).
  resolveFontFromLabel(selectEl) {
    const opt = selectEl && selectEl.selectedOptions ? selectEl.selectedOptions[0] : null;
    const title = opt && opt.textContent ? opt.textContent.trim() : '';
    if (!title) return null;
    const norm = (s) => s.toLowerCase().replace(/[^a-z0-9]/g, '');
    const target = norm(title);
    if (!target) return null;
    return Object.keys(this.fontMap).find((key) => norm(key) === target) || null;
  },

  loadFontIfNeeded(fontName) {
    return new Promise((resolve) => {
      if (!fontName || this.loadedFonts.has(fontName)) {
        resolve();
        return;
      }
      const fontUrl = this.fontLoadMap[fontName];
      if (!fontUrl) {
        // Self-hosted @font-face (every engraving font except the Google ones).
        // These are NOT in fontLoadMap, so this used to resolve instantly —
        // before the file had actually loaded — and the first render measured
        // against the fallback font and mis-sized the text. The setTimeout
        // passes in the change handler usually papered over it; on a brand-new
        // font with a cold cache they would not.
        const family = this.fontMap[fontName];
        if (family && document.fonts && document.fonts.load) {
          document.fonts
            .load('16px ' + family.split(',')[0].trim())
            .then(() => {
              this.loadedFonts.add(fontName);
              resolve();
            })
            .catch(() => resolve());
          return;
        }
        resolve();
        return;
      }
      const linkEl = document.createElement('link');
      linkEl.rel = 'stylesheet';
      linkEl.href = fontUrl;
      linkEl.onload = () => {
        this.loadedFonts.add(fontName);
        // Wait some frames for layout
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            setTimeout(() => resolve(), 50);
          });
        });
      };
      linkEl.onerror = () => resolve();
      document.head.appendChild(linkEl);
    });
  },

  updatePreview() {
    clearTimeout(this._updateTimer);
    const spinner = document.querySelector('.loading-spinner');
    if (spinner) spinner.style.display = 'block';
    this._updateTimer = setTimeout(() => this._doUpdatePreview(), 200);
  },

  _doUpdatePreview() {
    const isBack = this.state.showBack;
    if (this.debug) console.log('updatePreview => side:', isBack ? 'Back' : 'Front');

    const spinner = document.querySelector('.loading-spinner');
    if (!document.querySelector('.tag-preview')) return;
    if (spinner) spinner.style.display = 'block';

    if (!isBack) {
      this._renderFront();
    } else {
      this._renderBackWithMargin();
    }

    if (spinner) {
      requestAnimationFrame(() => {
        spinner.style.display = 'none';
      });
    }
  },

  // ---------------------------------------------
  // FRONT: original spiral approach
  // ---------------------------------------------
  _renderFront() {
    const previewEl = document.querySelector('.tag-preview');
    if (!previewEl) return;
    const container = document.querySelector('.preview-lines');
    container.innerHTML = '';

    const linesRaw = [this.state.frontLine1, this.state.frontLine2];
    const trimmed = linesRaw.filter(x => x.trim() !== '');
    const finalLines = trimmed.length ? trimmed : ['e.g. Pup’s Name'];

    const cssFont = this.fontMap[this.state.frontFont] || 'inherit';
    container.style.fontFamily = cssFont;
    container.style.color = (this.state.color === 'silver' ? '#000' : '#fff');
    container.style.lineHeight = '1.0';

    const designKey = this.state.frontDesign;
    const fullMask = this.frontMaskDataMap[designKey] || null;
    const designUrl = this.frontDesignImageMap[designKey] || 'none';

    // If designUrl is '', we show no background
    previewEl.style.backgroundImage = designUrl === 'none' ? 'none' : `url("${designUrl}")`;

    // Hidden div for measuring text
    const measureDiv = document.createElement('div');
    measureDiv.style.position = 'absolute';
    measureDiv.style.visibility = 'hidden';
    measureDiv.style.whiteSpace = 'nowrap';
    measureDiv.style.fontFamily = cssFont;
    document.body.appendChild(measureDiv);

    const maxSearchFontSize = 120;
    const avoidMargin = this.FRONT_AVOID_MARGIN;

    let safeMask = null;
    if (fullMask) {
      // For "plain" or any front design, we always have a hole mask 
      // so text avoids the top ring hole.
      safeMask = this.computeAdaptiveSafeMask(fullMask);
    }

    const baseCenterX = this.CANVAS_SIZE / 2;
    const baseCenterY = this.CANVAS_SIZE / 2;

    // If there's a design, we adapt to its shape;
    // otherwise for "plain", the safe mask is basically all white except the hole.
    let targetCenterX = baseCenterX;
    let targetCenterY = baseCenterY;
    if (safeMask) {
      const balance = this.computeGraphicBalance(safeMask);
      targetCenterX = balance.centerX;
      targetCenterY = balance.centerY;
    }

    const candidates = [];
    const letterSpacingOptions = [-1, 0, 1];
    const lineSpacingOptions = [1.0, 0.95, 0.9];
    const fontPenaltyFactor = 100;
    const letterSpacingPenaltyFactor = 50;
    const hierarchyBonusFactor = 10;

    function boxesOverlap(a, b) {
      return !(
        a.x + a.w < b.x ||
        a.x > b.x + b.w ||
        a.y + a.h < b.y ||
        a.y > b.y + b.h
      );
    }

    const measureLine = (text, fontSize, lineSpacing, letterSpacing) => {
      measureDiv.style.fontSize = fontSize + "px";
      measureDiv.style.lineHeight = lineSpacing.toString();
      measureDiv.style.letterSpacing = letterSpacing + "px";
      measureDiv.textContent = text;
      const r = measureDiv.getBoundingClientRect();
      return { width: r.width, height: r.height };
    };

    const spiralOffsets = this.buildSpiralOffsets(60, 10);

    // We try from big to small, with varied line/letter spacing
    for (let fs = maxSearchFontSize; fs >= 8; fs--) {
      for (const ls of lineSpacingOptions) {
        for (const letterSpacing of letterSpacingOptions) {
          // Uniform sizing
          {
            const measured = finalLines.map(txt => measureLine(txt, fs, ls, letterSpacing));
            const blockHeight = measured.reduce((sum, m) => sum + m.height, 0);
            const blockWidth = Math.max(...measured.map(m => m.width));

            for (const [offX, offY] of spiralOffsets) {
              let allSafe = true;
              const placedBoxes = [];
              const startX = targetCenterX + offX - (blockWidth / 2);
              let startY = targetCenterY + offY - (blockHeight / 2);
              let yCursor = startY;

              for (let i = 0; i < measured.length; i++) {
                const m = measured[i];
                const lineX = targetCenterX + offX - (m.width / 2);
                const lineY = yCursor;

                // Check circle boundary
                if (!this.inCircle(lineX, lineY, m.width, m.height, baseCenterX, baseCenterY, this.CIRCLE_RADIUS - avoidMargin)) {
                  allSafe = false;
                  break;
                }

                // Check hole or design
                if (safeMask && !this.isRectangleSafe(lineX, lineY, m.width, m.height, safeMask)) {
                  allSafe = false;
                  break;
                }

                // Check overlap
                const newBox = { x: lineX, y: lineY, w: m.width, h: m.height };
                for (const box of placedBoxes) {
                  if (boxesOverlap(newBox, box)) {
                    allSafe = false;
                    break;
                  }
                }
                if (!allSafe) break;

                placedBoxes.push(newBox);
                yCursor += m.height;
              }

              if (allSafe) {
                const candCenterX = targetCenterX + offX;
                const candCenterY = targetCenterY + offY;
                const dx = candCenterX - targetCenterX;
                const dy = candCenterY - targetCenterY;
                const dist2 = dx*dx + dy*dy;
                const fontPenalty = fontPenaltyFactor*(maxSearchFontSize - fs);
                const letterSpacingPenalty = Math.abs(letterSpacing)*letterSpacingPenaltyFactor;
                const score = dist2 + fontPenalty + letterSpacingPenalty;

                const positions = [];
                yCursor = startY;
                for (let i = 0; i < measured.length; i++) {
                  const m = measured[i];
                  const lineX = targetCenterX + offX - (m.width / 2);
                  positions.push({ text: finalLines[i], x: lineX, y: yCursor, fontSize: fs });
                  yCursor += m.height;
                }
                candidates.push({ fs, ls, letterSpacing, positions, score });
              }
            }
          }

          // Hierarchical approach (only if 2 lines)
          if (finalLines.length === 2) {
            for (const hierarchyDelta of [2, 4]) {
              const fs1 = fs + hierarchyDelta;
              const fs2 = fs;
              const m1 = measureLine(finalLines[0], fs1, ls, letterSpacing);
              const m2 = measureLine(finalLines[1], fs2, ls, letterSpacing);
              const blockHeight = m1.height + m2.height;
              const blockWidth = Math.max(m1.width, m2.width);

              for (const [offX, offY] of spiralOffsets) {
                let allSafe = true;
                const placedBoxes = [];
                const startX = targetCenterX + offX - (blockWidth / 2);
                let startY = targetCenterY + offY - (blockHeight / 2);

                // line1
                const line1X = targetCenterX + offX - (m1.width / 2);
                const line1Y = startY;
                if (!this.inCircle(line1X, line1Y, m1.width, m1.height, baseCenterX, baseCenterY, this.CIRCLE_RADIUS - avoidMargin)) {
                  allSafe = false;
                }
                if (allSafe && safeMask && !this.isRectangleSafe(line1X, line1Y, m1.width, m1.height, safeMask)) {
                  allSafe = false;
                }
                if (allSafe) {
                  placedBoxes.push({ x: line1X, y: line1Y, w: m1.width, h: m1.height });
                }

                // line2
                const line2X = targetCenterX + offX - (m2.width / 2);
                const line2Y = startY + m1.height;
                if (allSafe && !this.inCircle(line2X, line2Y, m2.width, m2.height, baseCenterX, baseCenterY, this.CIRCLE_RADIUS - avoidMargin)) {
                  allSafe = false;
                }
                if (allSafe && safeMask && !this.isRectangleSafe(line2X, line2Y, m2.width, m2.height, safeMask)) {
                  allSafe = false;
                }
                if (allSafe) {
                  const newBox = { x: line2X, y: line2Y, w: m2.width, h: m2.height };
                  for (const box of placedBoxes) {
                    if (boxesOverlap(newBox, box)) {
                      allSafe = false;
                      break;
                    }
                  }
                  if (allSafe) {
                    placedBoxes.push(newBox);
                  }
                }

                if (allSafe) {
                  const candCenterX = targetCenterX + offX;
                  const candCenterY = targetCenterY + offY;
                  const dx = candCenterX - targetCenterX;
                  const dy = candCenterY - targetCenterY;
                  const dist2 = dx*dx + dy*dy;
                  const fontPenalty = fontPenaltyFactor*(maxSearchFontSize - fs);
                  const letterSpacingPenalty = Math.abs(letterSpacing)*letterSpacingPenaltyFactor;
                  const hierarchyBonus = hierarchyDelta*hierarchyBonusFactor;
                  const score = dist2 + fontPenalty + letterSpacingPenalty - hierarchyBonus;

                  const positions = [
                    { text: finalLines[0], x: line1X, y: line1Y, fontSize: fs1 },
                    { text: finalLines[1], x: line2X, y: line2Y, fontSize: fs2 }
                  ];
                  candidates.push({ fs, ls, letterSpacing, hierarchyDelta, positions, score });
                }
              }
            }
          }
        }
      }
    }

    measureDiv.remove();

    if (!candidates.length) {
      // Fallback if no valid placement
      container.style.fontSize = '12px';
      finalLines.forEach((txt, i) => {
        const d = document.createElement('div');
        d.className = 'preview-line';
        d.textContent = txt;
        d.style.left = '0';
        d.style.right = '0';
        d.style.textAlign = 'center';
        d.style.top = (130 + i * 16) + 'px';
        container.appendChild(d);
      });
      if (this.debug) console.log('No placement found. Falling back (front).');
      return;
    }

    // Sort by score, best is first
    candidates.sort((a, b) => a.score - b.score);
    const best = candidates[0];
    if (this.debug) {
      console.log('All valid front candidates:', candidates);
      console.log('Best front candidate:', best);
    }

    best.positions.forEach(pos => {
      const d = document.createElement('div');
      d.className = 'preview-line';
      d.style.left = pos.x + 'px';
      d.style.top = pos.y + 'px';
      d.style.fontSize = pos.fontSize + 'px';
      d.style.letterSpacing = best.letterSpacing + 'px';
      d.textContent = pos.text;
      container.appendChild(d);
    });

    // Fade in
    container.style.opacity = '0';
    requestAnimationFrame(() => {
      container.style.transition = 'opacity 0.2s ease-in';
      container.style.opacity = '1';
    });
  },

  // ---------------------------------------------
  // BACK: largest text approach w/ margin
  // ---------------------------------------------
  _renderBackWithMargin() {
    const previewEl = document.querySelector('.tag-preview');
    if (!previewEl) return;
    const container = document.querySelector('.preview-lines');
    container.innerHTML = '';

    const linesRaw = [this.state.backLine1, this.state.backLine2, this.state.backLine3];
    const trimmed = linesRaw.filter(x => x.trim() !== '');
    const finalLines = trimmed.length ? trimmed : ['e.g. Phone # or short note'];

    const cssFont = this.fontMap[this.state.backFont] || 'inherit';
    container.style.fontFamily = cssFont;
    container.style.color = (this.state.color === 'silver' ? '#000' : '#fff');
    container.style.lineHeight = '1.0';

    // No hole on back, simpler approach
    const designKey = this.state.backDesign;
    const fullMask = this.backMaskDataMap[designKey] || null;
    const designUrl = this.backDesignImageMap[designKey] || 'none';

    previewEl.style.backgroundImage = designUrl === 'none' ? 'none' : `url("${designUrl}")`;

    // bounding-box approach from large to small
    const measureDiv = document.createElement('div');
    measureDiv.style.position = 'absolute';
    measureDiv.style.visibility = 'hidden';
    measureDiv.style.whiteSpace = 'nowrap';
    measureDiv.style.fontFamily = cssFont;
    document.body.appendChild(measureDiv);

    const baseCenterX = this.CANVAS_SIZE / 2;
    const baseCenterY = this.CANVAS_SIZE / 2;
    const margin = this.BACK_AVOID_MARGIN;
    const effectiveRadius = this.CIRCLE_RADIUS - margin;

    let bestSize = 0;
    for (let fs = 200; fs >= 8; fs--) {
      let totalHeight = 0;
      let maxWidth = 0;
      measureDiv.style.fontSize = fs + 'px';
      measureDiv.style.lineHeight = '1.0';
      measureDiv.style.letterSpacing = '0px';

      for (const ln of finalLines) {
        measureDiv.textContent = ln;
        const r = measureDiv.getBoundingClientRect();
        if (r.width > maxWidth) maxWidth = r.width;
        totalHeight += r.height;
      }

      // bounding box corners
      const blockLeft = baseCenterX - (maxWidth / 2);
      const blockTop = baseCenterY - (totalHeight / 2);
      const corners = [
        [blockLeft, blockTop],
        [blockLeft + maxWidth, blockTop],
        [blockLeft, blockTop + totalHeight],
        [blockLeft + maxWidth, blockTop + totalHeight]
      ];
      let fitsCircle = true;
      for (const [cx, cy] of corners) {
        const dx = cx - baseCenterX;
        const dy = cy - baseCenterY;
        if (dx*dx + dy*dy > effectiveRadius*effectiveRadius) {
          fitsCircle = false;
          break;
        }
      }
      if (fitsCircle) {
        bestSize = fs;
        break;
      }
    }

    measureDiv.remove();

    if (bestSize < 8) {
      // fallback
      container.style.fontSize = '12px';
      finalLines.forEach((txt, i) => {
        const d = document.createElement('div');
        d.className = 'preview-line';
        d.textContent = txt;
        d.style.left = '0';
        d.style.right = '0';
        d.style.textAlign = 'center';
        d.style.top = (130 + i * 16) + 'px';
        container.appendChild(d);
      });
      if (this.debug) console.log('No placement found. Falling back (back).');
      return;
    }

    // Render at bestSize
    const measureDiv2 = document.createElement('div');
    measureDiv2.style.position = 'absolute';
    measureDiv2.style.visibility = 'hidden';
    measureDiv2.style.whiteSpace = 'nowrap';
    measureDiv2.style.fontFamily = cssFont;
    measureDiv2.style.fontSize = bestSize + 'px';
    measureDiv2.style.lineHeight = '1.0';
    measureDiv2.style.letterSpacing = '0px';
    document.body.appendChild(measureDiv2);

    let totalHeight = 0;
    let maxWidth = 0;
    const linesMetrics = [];
    for (const ln of finalLines) {
      measureDiv2.textContent = ln;
      const r = measureDiv2.getBoundingClientRect();
      linesMetrics.push({ text: ln, width: r.width, height: r.height });
      if (r.width > maxWidth) maxWidth = r.width;
      totalHeight += r.height;
    }
    measureDiv2.remove();

    const blockLeft = baseCenterX - (maxWidth / 2);
    let yCursor = baseCenterY - (totalHeight / 2);
    for (const m of linesMetrics) {
      const d = document.createElement('div');
      d.className = 'preview-line';
      d.style.fontSize = bestSize + 'px';
      d.style.letterSpacing = '0px';
      d.textContent = m.text;
      const lineLeft = baseCenterX - (m.width / 2);
      d.style.left = lineLeft + 'px';
      d.style.top = yCursor + 'px';
      container.appendChild(d);
      yCursor += m.height;
    }

    // Fade in
    container.style.opacity = '0';
    requestAnimationFrame(() => {
      container.style.transition = 'opacity 0.2s ease-in';
      container.style.opacity = '1';
    });
  },

  buildSpiralOffsets(maxOffset, step) {
    const offsets = [[0, 0]];
    let dist = step;
    const directions = [
      [0, -1],
      [1, 0],
      [0, 1],
      [-1, 0]
    ];
    let dirIndex = 0;
    while (dist <= maxOffset) {
      for (let edge = 0; edge < 2; edge++) {
        const [dx, dy] = directions[dirIndex % 4];
        for (let i = 0; i < dist; i += step) {
          const last = offsets[offsets.length - 1];
          offsets.push([ last[0] + dx * step, last[1] + dy * step ]);
        }
        dirIndex++;
      }
      dist += step;
    }
    return offsets;
  },

  inCircle(x, y, w, h, cx, cy, r) {
    // Check if all 4 corners are inside the circle
    const corners = [
      [x, y],
      [x + w, y],
      [x, y + h],
      [x + w, y + h]
    ];
    for (const [px, py] of corners) {
      const dx = px - cx;
      const dy = py - cy;
      if (dx*dx + dy*dy > r*r) return false;
    }
    return true;
  },

  computeAdaptiveSafeMask(fullMask) {
    // Downsample to 30x30 for quick checking
    const scale = 30 / this.CANVAS_SIZE;
    const safeMask = [];
    const cellSize = 1 / scale;
    const brightnessValues = [];

    for (let j = 0; j < 30; j++) {
      safeMask[j] = [];
      for (let i = 0; i < 30; i++) {
        let sum = 0, count = 0;
        const startX = Math.floor(i * cellSize);
        const startY = Math.floor(j * cellSize);
        for (let y = startY; y < startY + cellSize; y++) {
          for (let x = startX; x < startX + cellSize; x++) {
            const idx = (y * fullMask.width + x) * 4;
            const r = fullMask.data[idx],
                  g = fullMask.data[idx+1],
                  b = fullMask.data[idx+2];
            const brightness = (r + g + b) / 3;
            sum += brightness;
            count++;
          }
        }
        const avg = sum / count;
        brightnessValues.push(avg);
        safeMask[j][i] = avg;
      }
    }

    brightnessValues.sort((a, b) => a - b);
    const median = brightnessValues[Math.floor(brightnessValues.length / 2)];
    for (let j = 0; j < 30; j++) {
      for (let i = 0; i < 30; i++) {
        safeMask[j][i] = (safeMask[j][i] >= median);
      }
    }

    if (this.debug) {
      console.log('Adaptive safe mask (median=' + median + '):', safeMask);
    }
    return safeMask;
  },

  computeGraphicBalance(safeMask) {
    // Weighted center of the "white" region in the mask
    let sumX = 0, sumY = 0, count = 0;
    const cellSize = this.CANVAS_SIZE / 30;
    for (let j = 0; j < 30; j++) {
      for (let i = 0; i < 30; i++) {
        if (safeMask[j][i]) {
          sumX += (i + 0.5) * cellSize;
          sumY += (j + 0.5) * cellSize;
          count++;
        }
      }
    }
    if (count === 0) return { centerX: 150, centerY: 150 };
    return { centerX: sumX / count, centerY: sumY / count };
  },

  isRectangleSafe(x, y, w, h, safeMask) {
    // Check if all 30x30 cells under the rectangle are "safe"
    const scale = 30 / this.CANVAS_SIZE;
    const startCol = Math.floor(x * scale);
    const startRow = Math.floor(y * scale);
    const endCol = Math.ceil((x + w) * scale);
    const endRow = Math.ceil((y + h) * scale);

    for (let r = startRow; r < endRow; r++) {
      for (let c = startCol; c < endCol; c++) {
        if (!safeMask[r] || !safeMask[r][c]) return false;
      }
    }
    return true;
  },

  async loadMaskData(url) {
    const canvas = document.createElement('canvas');
    canvas.width = this.CANVAS_SIZE;
    canvas.height = this.CANVAS_SIZE;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, this.CANVAS_SIZE, this.CANVAS_SIZE);

    const img = new Image();
    img.crossOrigin = 'Anonymous';
    img.src = url;
    await new Promise((res, rej) => { img.onload = res; img.onerror = rej; });
    ctx.drawImage(img, 0, 0, this.CANVAS_SIZE, this.CANVAS_SIZE);

    return ctx.getImageData(0, 0, this.CANVAS_SIZE, this.CANVAS_SIZE);
  },

  // loadMaskData rejects on img.onerror but never on a hung request, and its
  // only original caller sat inside preloadAllDesigns(), which init() wraps in
  // a .catch(). The fallback path below has no such umbrella, so it needs both
  // a timeout and its own error handling.
  loadMaskDataWithTimeout(url, ms) {
    return Promise.race([
      this.loadMaskData(url),
      new Promise((_, rej) =>
        setTimeout(() => rej(new Error('mask load timed out: ' + url)), ms)
      )
    ]);
  },

  // ======================================================
  // Fallback artwork for designs with no explicit mapping
  //
  // frontDesignValueMap / frontDesignImageMap are a hand-maintained mirror of
  // the MageWorx admin. Anything added there but not here used to be a SILENT
  // no-op in the change handler. This resolves the artwork from the swatch the
  // shopper just clicked instead, so a design added in the admin previews with
  // no theme change.
  //
  // Explicit map entries still win — the two sources are the same picture but
  // NOT byte-identical (MageWorx re-encodes, and the alpha channel differs
  // enough to shift computeAdaptiveSafeMask's median threshold and therefore
  // the text layout). Existing designs keep their known-good masks; this is a
  // safety net for new ones, not a replacement.
  //
  // DO NOT add these URLs to frontDesignImageMap at init time. preloadAllDesigns
  // walks that map serially with await and blocks the preview UI from appearing;
  // it already pulls roughly 6.6MB of full-size PNGs. This path stays lazy.
  // ======================================================

  // The DOM swatch is a 100px thumbnail; the same URL takes a size query.
  // 600 is deliberate — the mask canvas is CANVAS_SIZE (300) and the CSS
  // renders at 320px, so 600 is already 2x retina for both, at ~62KB against
  // ~440KB for the query-less 2048px original that a shopper would pay for on
  // the first tap.
  SWATCH_ART_SIZE: 600,

  _fallbackArtState: {},

  swatchArtworkUrl(radioEl) {
    const valueEl = radioEl && radioEl.closest
      ? radioEl.closest('.mw-option__value')
      : null;
    const img = valueEl ? valueEl.querySelector('img.mw-option__swatch-image') : null;
    const src = img ? (img.getAttribute('src') || img.src || '') : '';
    if (!src) return null;
    const base = src.split('?')[0];
    return base + '?width=' + this.SWATCH_ART_SIZE + '&height=' + this.SWATCH_ART_SIZE;
  },

  async adoptUnmappedDesign(valueId, radioEl) {
    const url = this.swatchArtworkUrl(radioEl);
    if (!url) {
      // A value created in the admin before its artwork was uploaded has no
      // <img> to read. Say so rather than leaving a wrong preview on screen.
      console.warn(
        '[tag-preview] design ' + valueId + ' has no mapping and no swatch image; ' +
        'preview cannot resolve its artwork.'
      );
      return;
    }

    // Show the artwork straight away. The mask only refines where text may sit,
    // so the visible response must never wait on a network round-trip to a
    // third-party host.
    this.frontDesignImageMap[valueId] = url;
    if (!this.frontMaskDataMap[valueId]) {
      this.frontMaskDataMap[valueId] = this.buildHoleMask();
    }
    this.state.frontDesign = valueId;
    if (!this.state.showBack) this.updatePreview();

    if (this._fallbackArtState[valueId]) return;
    this._fallbackArtState[valueId] = 'pending';

    try {
      const mask = await this.loadMaskDataWithTimeout(url, 8000);
      this.paintRingHoleBlack(mask);
      this.frontMaskDataMap[valueId] = mask;
      this._fallbackArtState[valueId] = 'loaded';
      if (!this.state.showBack && this.state.frontDesign === valueId) {
        this.updatePreview();
      }
    } catch (err) {
      // Keep the plain hole mask: text stays inside the tag and clear of the
      // ring hole, it just won't dodge this design's graphic.
      this._fallbackArtState[valueId] = 'failed';
      console.warn('[tag-preview] mask fallback failed for ' + valueId + ':', err);
    }
  },

  buildHoleMask() {
    // Create a 300x300 white area with ring hole in black (so text avoids it)
    const c = document.createElement('canvas');
    c.width = this.CANVAS_SIZE;
    c.height = this.CANVAS_SIZE;
    const ctx = c.getContext('2d');
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, this.CANVAS_SIZE, this.CANVAS_SIZE);
    ctx.beginPath();
    ctx.arc(this.HOLE_CENTER_X, this.HOLE_CENTER_Y, this.HOLE_RADIUS, 0, 2*Math.PI);
    ctx.fillStyle = '#000';
    ctx.fill();
    return ctx.getImageData(0, 0, this.CANVAS_SIZE, this.CANVAS_SIZE);
  },

  paintRingHoleBlack(imgData) {
    // Overwrite the hole area with black so text avoids it
    if (!imgData) return;
    const { data, width, height } = imgData;
    const left = Math.max(0, this.HOLE_CENTER_X - this.HOLE_RADIUS);
    const top = Math.max(0, this.HOLE_CENTER_Y - this.HOLE_RADIUS);
    const right = Math.min(width - 1, this.HOLE_CENTER_X + this.HOLE_RADIUS);
    const bottom = Math.min(height - 1, this.HOLE_CENTER_Y + this.HOLE_RADIUS);
    const rr = this.HOLE_RADIUS * this.HOLE_RADIUS;

    for (let py = top; py <= bottom; py++) {
      const row = py * width * 4;
      for (let px = left; px <= right; px++) {
        const dx = px - this.HOLE_CENTER_X;
        const dy = py - this.HOLE_CENTER_Y;
        if (dx*dx + dy*dy <= rr) {
          const idx = row + px*4;
          data[idx]   = 0;
          data[idx+1] = 0;
          data[idx+2] = 0;
          data[idx+3] = 255;
        }
      }
    }
  },

  // ======================================================
  // Methods for capturing a laser-ready canvas (NO border)
  // ======================================================
  async renderFrontToCanvas() {
    const previewEl = document.querySelector('.tag-preview');
    if (!previewEl) throw new Error("No .tag-preview element found for front capture.");
    
    // Hide ring hole & black border
    previewEl.classList.add('no-laser-border');
    
    // Wait a bit for CSS changes
    await new Promise(r => setTimeout(r, 80));

    // html2canvas capture
    const canvas = await html2canvas(previewEl, {
      useCORS: true,
      scale: 1,
      backgroundColor: null
    });
    
    // Revert
    previewEl.classList.remove('no-laser-border');
    return canvas;
  },

  async renderBackToCanvas() {
    const previewEl = document.querySelector('.tag-preview');
    if (!previewEl) throw new Error("No .tag-preview element found for back capture.");

    previewEl.classList.add('no-laser-border');
    
    // Wait a bit for CSS changes
    await new Promise(r => setTimeout(r, 80));

    // html2canvas capture
    const canvas = await html2canvas(previewEl, {
      useCORS: true,
      scale: 3
    });
    
    // Revert
    previewEl.classList.remove('no-laser-border');
    return canvas;
  }
};

// Initialize
document.addEventListener('DOMContentLoaded', () => {
  window.TagPreviewIntegration.init();
});